<template>
  <v-btn
      color="blue"
      variant="text"
      :disabled="isDisabled"
      @click="Clicked"
  >
    {{buttonText}}
  </v-btn>
</template>

<script setup lang="ts">


defineProps({
  isDisabled: Boolean,
  buttonText: String
});

const emits = defineEmits(["click"]);

const Clicked = () => {
  emits("click");
};
</script>
